"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExprObject = exports.tryEvalExpr = exports.deepInterop = exports.stringInterop = void 0;
const lodash_1 = require("lodash");
const eval_1 = require("@tencent/data-schema-core/lib/utils/eval");
Object.defineProperty(exports, "tryEvalExpr", { enumerable: true, get: function () { return eval_1.tryEvalExpr; } });
Object.defineProperty(exports, "isExprObject", { enumerable: true, get: function () { return eval_1.isExprObject; } });
/** 对字符串做花括号插值 */
function stringInterop(str, ...ctxs) {
    if (typeof str !== 'string')
        return str;
    if (str.startsWith('{{') && str.indexOf('}}') === str.length - 2) {
        // 整个字符串就是一个表达式，返回值就不是 string
        return (0, eval_1.tryEvalExpr)(str.slice(2, -2), undefined, ...ctxs);
    }
    return str.replace(/{{([\d\D]+?)}}/g, (whole, path) => (0, eval_1.tryEvalExpr)(path, undefined, ...ctxs));
    // return str.replace(/\{\{([^}]+)\}\}/g, (_, path) => get(ctx, path.trim()));
}
exports.stringInterop = stringInterop;
function deepInterop(value, ...ctxs) {
    const process = (val) => {
        if (typeof val === 'string')
            return stringInterop(val, ...ctxs);
        if (Array.isArray(val))
            return val.map(process);
        if ((0, lodash_1.isPlainObject)(val))
            return (0, lodash_1.mapValues)(val, process);
        return val;
    };
    return process(value);
}
exports.deepInterop = deepInterop;
//# sourceMappingURL=script.js.map